import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询物品借用列表
export function listBorrows(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrow.listBorrows',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加物品借用
export function saveBorrow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrow.saveBorrow',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新物品借用
export function updateBorrow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrow.updateBorrow',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除物品借用
export function deleteBorrow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrow.deleteBorrow',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询物品借用类型列表
export function listBorrowTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrowType/queryBorrowType',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}